import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';

export const useVerifyEmail = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: verifyEmail,
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['customer', 'account'] }),
  });
};

const verifyEmail = async (props: VerifyEmailBody) =>
  api.put<void>(apiConfig.routes.auth.verifyEmail, props);

type VerifyEmailBody = {
  email: string;
  token: string;
};
